import React from 'react';
import classNames from 'classnames';
import { OutlinedInput, Typography, withStyles } from '@material-ui/core';

const TextField = ({ classes, className, label, ...rest }) => {
  return (
    <div className={classNames(classes.container, className)}>
      <Typography variant="caption">{label}</Typography>
      <OutlinedInput
        labelWidth={0}
        className={classes.input}
        classes={{
          inputMarginDense: classes.inputMarginDense,
        }}
        margin="dense"
        fullWidth={false}
        {...rest}
      />
    </div>
  );
};

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  input: {
    backgroundColor: theme.palette.background.paper,
    fontSize: theme.typography.pxToRem(12)
  },
  inputMarginDense: {
    padding: theme.spacing.unit / 2,
    paddingTop: theme.spacing.unit / 2,
    paddingBottom: theme.spacing.unit / 2,
  },
});

export default withStyles(styles)(TextField);
